import { __decorate, __metadata } from "tslib";
import { Component, Prop } from "vue-property-decorator";
import { LvButtonBorder, LvButtonDisplay } from "./model";
import { UIComponent } from "../UIComponent";
import { LvSpin } from "../spin";
export const COMPONENT_NAME = "LvButton";
/**
 * A button element
 */
let LvButton = class LvButton extends UIComponent {
    get classList() {
        return [
            "lv-button",
            this.display,
            this.color,
            this.hollow ? "hollow" : null,
            this.size,
            this.border,
            this.shape
        ].filter(x => x != null);
    }
    get shouldDisable() {
        return this.disabled || this.loading;
    }
};
__decorate([
    Prop({ type: String, required: false, default: "button" }),
    __metadata("design:type", String)
], LvButton.prototype, "type", void 0);
__decorate([
    Prop({ type: String, required: false, default: LvButtonDisplay.Inline }),
    __metadata("design:type", String)
], LvButton.prototype, "display", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvButton.prototype, "color", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvButton.prototype, "hollow", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvButton.prototype, "size", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvButton.prototype, "loading", void 0);
__decorate([
    Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], LvButton.prototype, "disabled", void 0);
__decorate([
    Prop({ type: String, required: false, default: LvButtonBorder.Solid }),
    __metadata("design:type", Object)
], LvButton.prototype, "border", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], LvButton.prototype, "shape", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", String)
], LvButton.prototype, "link", void 0);
__decorate([
    Prop({ type: String, required: false, default: null }),
    __metadata("design:type", String)
], LvButton.prototype, "href", void 0);
LvButton = __decorate([
    Component({
        name: COMPONENT_NAME,
        components: { LvSpin },
    })
], LvButton);
export default LvButton;
//# sourceMappingURL=script.js.map